<template>
  <b-modal
    id="common-attendance-modal"
    :title="title"
    title-class="h4 font-weight-bold"
    lazy
    size="xl"
    hide-footer
  >
    <slot> </slot>
  </b-modal>
</template>

<script>
export default {
  name: "CommonAttendanceModal",
  props: {
    title: {
      String,
    },
  },
};
</script>

<style scoped></style>
